import {
  ONBOARDING_EMPLOYEE_BYID_FAILED,
  ONBOARDING_EMPLOYEE_BYID_FETCHING,
  ONBOARDING_EMPLOYEE_BYID_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ONBOARDING_EMPLOYEE_BYID_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ONBOARDING_EMPLOYEE_BYID_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ONBOARDING_EMPLOYEE_BYID_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
